export function removeTrailingSlashes(str) {
  return str.replace(/[/]+$/, '')
}
